import { nodeType } from "../constants"

const getTempOrNodeIndexes = (nodes) =>
  nodes.reduce((reducedTempOrNodeIndexes, node, index) => {
    if (node.type !== nodeType.orOperator || node.isInitialized) {
      return reducedTempOrNodeIndexes
    }

    return [...reducedTempOrNodeIndexes, index]
  }, [])

const isOrOperatorValueNode = (node) =>
  node.type === nodeType.plainText ||
  node.type === nodeType.filterOperator ||
  (node.type === nodeType.orOperator && node.isInitialized)

const initializeTempOrNode = (node, index, array, tempOrNodeIndexes) => {
  if (node.type !== nodeType.orOperator || node.isInitialized) {
    return node
  }

  let leftValueIndex = null
  if (index - 1 >= 0) {
    let leftValueNode = array[index - 1]
    if (isOrOperatorValueNode(leftValueNode)) {
      leftValueIndex = index - 1
    }
  }

  let rightValueIndex = null
  if (array.length - 1 !== index) {
    let rightValueNode = array[index + 1]
    if (isOrOperatorValueNode(rightValueNode)) {
      rightValueIndex = index + 1
    }
  }

  if (leftValueIndex == null && rightValueIndex == null) {
    return {
      ...node,
      isInitialized: true,
      isEmpty: true,
      values: [],
      valueIndexes: [],
    }
  }

  if (leftValueIndex != null && tempOrNodeIndexes.indexOf(index - 2) != -1) {
    return node
  }

  let valueIndexes = [leftValueIndex, rightValueIndex].filter((i) => i != null)

  return {
    ...node,
    isInitialized: true,
    isEmpty: valueIndexes.length === 0,
    values: valueIndexes.map((i) => array[i]),
    valueIndexes,
  }
}

const initializeOrNode = (node) => {
  if (node.type !== nodeType.orOperator) {
    return node
  }

  if (node.values.length === 1) {
    return initializeOrNode(node.values[0])
  }

  return {
    type: node.type,
    values: node.values.map(initializeOrNode),
  }
}

export const initializeOrNodes = (nodes) => {
  let tempOrNodeIndexes = getTempOrNodeIndexes(nodes)
  let duplicateTempOrNodeIndexes = tempOrNodeIndexes.filter(
    (value, index, array) => array.indexOf(value + 1) !== -1,
  )
  nodes = nodes.filter((node, index) => duplicateTempOrNodeIndexes.indexOf(index) === -1)

  tempOrNodeIndexes = getTempOrNodeIndexes(nodes)
  while (tempOrNodeIndexes.length > 0) {
    nodes = nodes.map((value, index, array) =>
      initializeTempOrNode(value, index, array, tempOrNodeIndexes),
    )
    let indexesToRemove = nodes.reduce((reducedIndexesToRemove, node, index) => {
      if (node.type !== nodeType.orOperator || !node.isInitialized || node.isHandled) {
        return reducedIndexesToRemove
      }

      if (node.isEmpty) {
        return [...reducedIndexesToRemove, index]
      }
      if (node.valueIndexes != null) {
        return [...reducedIndexesToRemove, ...node.valueIndexes]
      }

      return reducedIndexesToRemove
    }, [])
    nodes = nodes
      .filter((node, index) => indexesToRemove.indexOf(index) === -1)
      .map((node) =>
        node.type === nodeType.orOperator && node.isInitialized
          ? { ...node, isHandled: true }
          : node,
      )
    tempOrNodeIndexes = getTempOrNodeIndexes(nodes)
  }

  return nodes.map(initializeOrNode)
}
